import { DateHelper } from "../lib/DateHelper"
import { OrderHelper } from "../OrderHelper"

export class Order {

	constructor(id) {
		this._id = id
	}

	setVariables = variables => {
		this._receiveDate = new Date(variables.receiveDateTime.value)
		this._startCookingDate = variables.startCookingDateTime.value ? new Date(variables.startCookingDateTime.value) : null
		this._cookingStartedDate = (variables.cookingStartedDateTime && variables.cookingStartedDateTime.value) ? new Date(variables.cookingStartedDateTime.value) : null
		this._deliveryDate = new Date(variables.deliveryDateTime.value)
		this._contact = variables.contact.value ? JSON.parse(variables.contact.value) : null
		this._delivery = variables.delivery.value
		this._deliveryAddress = variables.deliveryAddress.value ? JSON.parse(variables.deliveryAddress.value) : null
		this._storeId = variables.storeId.value
		this._storeContact = variables.storeContact.value ? JSON.parse(variables.storeContact.value) : null
		this._storeAddress = variables.storeAddress.value ? JSON.parse(variables.storeAddress.value) : null
		this._cart = variables.cart.value ? JSON.parse(variables.cart.value) : null
		this._net = variables.net.value
		this._tax = variables.tax.value
		this._payment = variables.payment.value ? JSON.parse(variables.payment.value) : null
		this._remarks = variables.remarks.value
		this._discounts = variables.discounts.value ? JSON.parse(variables.discounts.value) : null
		this._fees = variables.fees.value ? JSON.parse(variables.fees.value) : null
		this._invoiceNumber = variables.invoiceNumber ? variables.invoiceNumber.value : null
	}

	setOrder = (orderVO) => {
		this._receiveDate = orderVO.receiveDate
		this._deliveryDate = orderVO.deliveryDate
		this._contact = orderVO.contact
		this._delivery = orderVO.delivery
		this._deliveryAddress = orderVO.deliveryAddress
		this._storeId = orderVO.storeId
		this._storeContact = orderVO.storeContact
		this._storeAddress = orderVO.storeAddress
		this._net = orderVO.net
		this._tax = orderVO.tax
		this._payment = orderVO.payment
		this._remarks = orderVO.remarks
		this._discounts = orderVO.discounts
		this._fees = orderVO.fees
		this._invoiceNumber = orderVO.invoiceNumber
	}

	setCart = (cart) => {
		this._cart = cart
	}

	getIdString = () => this._id.substring(0, 8)

	getReceiveDateTimeString = includeTodyDate => DateHelper.formatDateTime(this._receiveDate, includeTodyDate)

	isDelivery = () => this._delivery === 'delivery'

	getDeliveryDateTime = includeTodyDate => DateHelper.formatDateTime(this._deliveryDate, includeTodyDate)

	getCustomerNameString = () => `${this._contact.firstName} ${this._contact.lastName}`

	getCustomerPhone = () => this._contact.phone

	getStoreId = () => this._storeId

	getStoreName = () => this._storeContact ? this._storeContact.company : null

	getStorePhone = () => this._storeContact ? this._storeContact.phone : null

	getStoreEMail = () => this._storeContact ? this._storeContact.email : null

	getCart = () => this._cart

	getCartItemsLabel = () => OrderHelper.renderLabel(this)

	getPrice = () => this._formatPrice(this._net + this._tax)

	getTax = () => this._formatPrice(this._tax)

	getPaymentMethod = () => this._payment.payWith

	getStoreAddressString = () => this._storeAddress ? `${this._storeAddress.street} ${this._storeAddress.nr}, ${this._storeAddress.postalCode} ${this._storeAddress.city}` : null

	getDeliveryAddressString = () => this.isDelivery() ? `${this._deliveryAddress.street} ${this._deliveryAddress.nr}, ${this._deliveryAddress.postalCode} ${this._deliveryAddress.city}` : 'Abholung'

	getShortDeliveryAddressString = () => this.isDelivery() ? `${this._deliveryAddress.street} ${this._deliveryAddress.nr}, ${this._deliveryAddress.postalCode} ${this._getShortCityName(this._deliveryAddress.city)}` : 'Abholung'

	// TODO Geo Pos

	getDoorbell = () => this.isDelivery() ? this._deliveryAddress.doorbell : null

	getRemarks = () => this._remarks

	getDiscounts = () => this._discounts

	getFees = () => this._fees

	getTasks = () => this._tasks

	getInvoiceNumber = () => this._invoiceNumber ? String(this._invoiceNumber % 10000).padStart(4, '0') : null

	_formatPrice = number => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number).replace(' ', '')

	_getShortCityName = name => name.match(/\w*(Bremen)\w*/i) === null ? name : 'HB'

}